export default {"src":"/_next/static/media/pause_regular.81ef59f5.svg","height":24,"width":24};